// import components
import { Box, styled } from '@mui/material';

/**
 * The filter icon and the entity symbols, side by side at the left of the toolbar — or stacked, when the
 * toolbar is docked to the side and runs vertically. Five icons in a row inside a vertical bar would push
 * straight out of it, so the axis follows the toolbar's, the way its dividers and tooltips already do.
 *
 * Its own gap rather than the toggle's: the symbols sit close together because they are one control, while
 * the filter icon is a separate control and keeps the toolbar's usual spacing away from them.
 */
export const LeadingControlsRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isVertical'
})<{ isVertical?: boolean }>(({ theme, isVertical }) => ({
  display: 'flex',
  flexDirection: isVertical ? 'column' : 'row',
  alignItems: 'center',
  gap: theme.spacing(1)
}));
